import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { AnhoService } from 'src/app/services/Anho.service';
import { Anho } from 'src/app/models/Anho';
import { FurSeguimientoService } from 'src/app/services/fur-seguimiento..service';
import { FurSeguimientoFiltro } from 'src/app/models/FurSeguimientoFiltro';
import { GetAnho, GlobalVars, NumIdEstadoRegistrado, NumIdEstadoAsignado, iconPanelContraer, NumIdEstadoHeEvaluacionSuperv, NumIdEstadoHeEvaluacionObservado, DscTituloPaginator, NumIdPrioridadNormal, NumIdPrioridadUrg, NumIdPrioridadMuyUrg, gvCanal, DscMensajeSpinner } from 'src/app/general/variables';
import { Fur } from 'src/app/models/Fur';
import { Router, ActivatedRoute } from '@angular/router';
import { CanalService } from 'src/app/services/canal.service';
import { Canal } from 'src/app/models/Canal';
import { MaestrasService } from 'src/app/services/maestra/maestras.service';
import { Estado } from 'src/app/models/Estado';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
@Component({
  selector: 'app-body-busqueda',
  templateUrl: './body-busqueda.component.html',
  styleUrls: ['./body-busqueda.component.css']
})
export class BodyBusquedaComponent implements OnInit {

  // general : General;
  strEtiquetaBusq: string;
  strEtiquetaResult: string;
  strEtiquetaRadioNoPen: string;
  strEtiquetaRadioPen: string;
  listAnho: Anho[] = [];
  idCanal = 3;
  flgMostrarResultado = false;
  // codDep:string;
  listFurSeguimiento: Fur[] = [];
  flgMostrarNuevo = false;
  strAnho: string = GetAnho().toString();
  strParametro: string;
  flgRadio = true; // false = pendiente
  @Output() opNuevoSeleccionado = new EventEmitter();
  @Output() opVerSeleccionado = new EventEmitter();
  @Output() opAsignarSeleccionado = new EventEmitter();
  @Output() opEvaluarSeleccionado = new EventEmitter();

  furSeguimientoFiltro: FurSeguimientoFiltro;
  idOpcionSelec: number;
  listCanal: Canal[] = [];
  listEstado: Estado[] = [];
  numIdTipoDocCan = 0;
  DscMensajeSpinner = DscMensajeSpinner;
  // flgDeshabilitarAsig = false;
  // flgDeshabilitarEdit = false;
  flgBuscarSoloReg = false;
  flgMostrarEditar = false;
  flgMostrarAsig = false;
  flgMostrarAten = false;
  flgMostrarVer = false;
  flgMostrarTipoDoc = false;
  flgContraerPanel = true;
  strIconPanel = '';
  /**Cus 06 */
  flgMostrarEval = false;
  /**/
  numIdEstado: number = (GlobalVars.FlgGestor ? NumIdEstadoAsignado : NumIdEstadoRegistrado);



  displayedColumns: string[] = [];
  // displayedColumns: string[] = [];

  strDscColBtnAsign = 'btnAsignar';
  strDscColBtnEdit = 'btnEditar';
  strDscColBtnVer = 'btnVer';
  strDscColBtnAten = 'btnAtender';
  strDscColBtnEval = 'btnEvaluar';

  strDscColCodEntrada = 'codEntrada';
  strDscColNroExpediente = 'nroExpediente';
  strDscColFchRecepcion = 'fchRecepcion';
  strDscColFchRegistro = 'fchRegistro';
  strDscColDscEstado = 'dscEstado';
  strDscColDscAsunto = 'dscAsunto';
  strDscColDscEntidad = 'dscEntidad';
  strDscColDscTipoDciante = 'dscTipoDciante';
  strDscColNroItem = 'nroItem';
  strDscColCodBorrador = 'codBorrador';
  strDscColTipoDocumento = 'codTipDoc';
  strDscColDscPriorizacion = 'nivelPriori';

  strDscColEtiqCodEntr = 'Código de Entrada';

  // matTableColumnsDef = ["item","codigo","expediente","fchRecep", "fchRegistro","estado","dscAsunto","dscEntidad","tipoDenunciante"];
  // matTableColumnsDef = ["codigo", "expediente", "fchRecep", "fchRegistro", "estado", "dscAsunto", "dscEntidad", "tipoDenunciante"];
  dataSource: MatTableDataSource<Fur>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;


  // flgMostrarSoloReg = false;
  //  flgSupervisor = GlobalVars.FlgSupervisor;


  // formBusqueda = new FormGroup({
  //   input_param : new FormControl(''),
  //   select_anho : new FormControl(''),

  // });

  constructor(protected anhoService: AnhoService,
              protected furSeguimientoService: FurSeguimientoService,
              public router: Router,
              private route: ActivatedRoute,
              protected canalService: CanalService,
              protected maestraService: MaestrasService,

  ) {

    this.dataSource = new MatTableDataSource();

    // this.displayedColumns = this.displayedColumnsDef;


  }

  ngOnInit() {



    if (this.paginator != null) {this.paginator._intl.itemsPerPageLabel = DscTituloPaginator; } // this.paginator._intl.itemsPerPageLabel = DscTituloPaginator;

    // this.paginator._intl.itemsPerPageLabel = DscTituloPaginator;


    this.flgMostrarResultado = false;

    // this.BuscarAsigSI();

    this.anhoService.listarAnho().subscribe(
      data => {
        this.listAnho = data;
      });

    this.canalService.listarCanalDocumento().subscribe(data => {

      this.listCanal = data;

    });

    this.maestraService.listarEstadoPorFicha('FUR').subscribe(data => {

      this.listEstado = data;

    });


    this.strIconPanel = iconPanelContraer(this.flgContraerPanel);


  }

  _panelFiltro() {

    this.flgContraerPanel = !this.flgContraerPanel;

    this.strIconPanel = iconPanelContraer(this.flgContraerPanel);



  }



  _checkSoloReg(event: any) {

    // console.log("==========event.target.checked");
    // console.log(event.target.checked);

    this.flgBuscarSoloReg = event.target.checked;

    // this.MostrarEtiquetas(this.idOpcionSelec,false);
    this._resetBusqueda();

  }

  _cambioAnho() {

    this._resetBusqueda();

  }

  _cambioTipoDoc() {

    this._resetBusqueda();

  }

  _cambioEstado() {

    this._resetBusqueda();

  }

  _resetBusqueda() {

    this.MostrarEtiquetas(this.idOpcionSelec, false);

  }

  _aplicaColorGrilla(numPrioridad: number) {

    let vNumColor = 0;

    switch (numPrioridad) {

      case NumIdPrioridadNormal:

        vNumColor = 1;

        break;

      case NumIdPrioridadUrg:

        vNumColor = 2;

        break;

      case NumIdPrioridadMuyUrg:

        vNumColor = 3;

        break;

      default:
        break;
    }

    return 'd' + vNumColor.toString();
    // return vNumColor;

    // console.log("========================index");
    // console.log(index);



    // return (index%2) ? true : false;

  }

  // _CambioSoloReg()
  // {

  // }

  MostrarEtiquetas(idOpcion: number, flgOpcionSelec: boolean) {

    let dscEtiqueta = '';
    let dscEtiqueta2 = '';
    let vFlgMostrarEdit = false;
    let vFlgMostrarNuevo = false;
    const vflgFiltroReg = this._recupFlgFiltroEstReg();
    const vflgFiltroAsig = this._recupFlgFiltroEstAsig();
    const vDscCampo1 = 'Formulario Virtual';

    // var vFlgMostrarAten = false;

    this.flgMostrarTipoDoc = false;

    // this.flgBuscarSoloReg = (flgOpcionSelec ? false : this.flgBuscarSoloReg);//SI ESTA FUNCION SE EJECUTA DESDE EL BODYOPCIONES

    this.idOpcionSelec = idOpcion;

    // this.codDep = codDep;//this.general.dscCampo1;
    // this.flgMostrarSoloReg = false;
    // this.flgMostrarNuevo = false;
    // this.flgRadio = true;//siempre muestra pendientes
    this.listFurSeguimiento = [];
    this.dataSource = new MatTableDataSource();
    // this.flgDeshabilitarAsig = (GlobalVars.FlgOtroUsuario ? true : !GlobalVars.FlgSupervisor);//APLICA PARA SUPERV
    // this.flgMostrarAsig = (GlobalVars.FlgOtroUsuario || !this.flgRadio ? false : GlobalVars.FlgSupervisor);//APLICA PARA SUPERV

    // this.flgMostrarAsig = (GlobalVars.FlgOtroUsuario || vflgFiltroAsig ? false : GlobalVars.FlgSupervisor);//APLICA PARA SUPERV
    this.flgMostrarAsig = (vflgFiltroReg && GlobalVars.FlgSupervisor ? true : false); // APLICA PARA SUPERV

    // vFlgMostrarEdit = (GlobalVars.FlgOtroUsuario || !this.flgBuscarSoloReg ? false : (GlobalVars.FlgGestor || GlobalVars.FlgSupervisor ? true : false));//;//APLICA PARA GESTOR
    // vFlgMostrarEdit = (GlobalVars.FlgOtroUsuario ? false : (GlobalVars.FlgGestor || GlobalVars.FlgSupervisor ? true : false));//;//APLICA PARA GESTOR
    vFlgMostrarEdit = vflgFiltroReg;

    // this.flgMostrarAten = (this.flgBuscarSoloReg ? false : GlobalVars.FlgGestor);
    // this.flgMostrarAten = GlobalVars.FlgGestor;
    // this.flgMostrarAten = (vflgFiltroReg ? false : GlobalVars.FlgGestor); // NO APLICA ATENCION CUANDO EL FILTRO DE ESTADO ES REG
    this.flgMostrarAten = (vflgFiltroAsig && GlobalVars.FlgGestor ? true : false); // NO APLICA ATENCION CUANDO EL FILTRO DE ESTADO ES REG

    // console.log("===========GlobalVars.FlgOtroUsuario");
    // console.log(GlobalVars.FlgOtroUsuario);
    // console.log("============GlobalVars.FlgGestor");
    // console.log(GlobalVars.FlgGestor);
    // console.log("============this.flgBuscarSoloReg");
    // console.log(this.flgBuscarSoloReg);

    // console.log("============GlobalVarsFlgSupervisor");
    // console.log(GlobalVars.FlgSupervisor);

    dscEtiqueta = (GlobalVars.FlgGestor ? 'Atendidos' : 'Asignados');
    dscEtiqueta2 = (GlobalVars.FlgGestor ? 'Atención' : 'Asignación');

    this.displayedColumns = [];

    this.displayedColumns.push(this.strDscColNroItem);

    switch (idOpcion) {

      case 1:

        this.strEtiquetaBusq = 'Expediente';
        this.strEtiquetaResult = 'Expedientes';

        this.idCanal = gvCanal.NumIdExp;
        vFlgMostrarNuevo = true;

        this.displayedColumns.push(this.strDscColCodEntrada);
        this.strDscColEtiqCodEntr = 'Cod. Entrada';

        this.displayedColumns.push(this.strDscColNroExpediente);
        this.displayedColumns.push(this.strDscColFchRecepcion);
        this.displayedColumns.push(this.strDscColDscTipoDciante);




        break;

      case 2:

        // strDscColCodEntrada = "codEntrada";
        // strDscColNroExpediente = "nroExpediente";
        //  = "fchRecepcion";
        // strDscColFchRegistro = "fchRegistro";
        // strDscColDscEstado = "dscEstado";
        // strDscColDscAsunto = "dscAsunto";
        // strDscColDscEntidad = "dscEntidad";
        // strDscColDscTipoDciante = "dscTipoDciante";

        // strDscColCodBorrador = "codBorrador";

        // strDscColEtiqCodEntr = "Código de Entrada";


        this.strEtiquetaBusq = vDscCampo1;
        this.strEtiquetaResult = 'Formularios Web';

        this.idCanal = gvCanal.NumFormWeb;
        vFlgMostrarEdit = false;

        this.displayedColumns.push(this.strDscColCodBorrador);
        this.displayedColumns.push(this.strDscColCodEntrada);
        this.displayedColumns.push(this.strDscColFchRecepcion);

        this.strDscColEtiqCodEntr = vDscCampo1;


        break;

      case 3:

        this.strEtiquetaBusq = 'Documento';
        this.strEtiquetaResult = 'Documentos';
        // this.strEtiquetaRadioNoPen = "Documentos Asignados";
        // this.strEtiquetaRadioPen = "Documentos Pendientes de Asignación";
        this.idCanal = 0;
        // this.flgMostrarNuevo = true;
        vFlgMostrarNuevo = true;
        this.flgMostrarTipoDoc = true;

        this.displayedColumns.push(this.strDscColCodEntrada);
        this.strDscColEtiqCodEntr = 'Número Registro';

        this.displayedColumns.push(this.strDscColTipoDocumento);
        this.displayedColumns.push(this.strDscColFchRegistro);


        break;

      case 4:

        this.strEtiquetaBusq = 'FUR';
        this.strEtiquetaResult = 'FUR\'s';

        this.idCanal = 99;

        vFlgMostrarEdit = false;

        this.displayedColumns.push(this.strDscColCodEntrada);
        this.strDscColEtiqCodEntr = 'FUR';

        this.displayedColumns.push(this.strDscColFchRecepcion);

        break;

      default:
        break;
    }

    this.flgMostrarEditar = vFlgMostrarEdit;

    this.flgMostrarNuevo = (GlobalVars.FlgOtroUsuario ? false : vFlgMostrarNuevo);
    this.flgMostrarVer = GlobalVars.FlgOtroUsuario;

    this.strEtiquetaRadioNoPen = `${this.strEtiquetaResult} ${dscEtiqueta}`;
    this.strEtiquetaRadioPen = `${this.strEtiquetaResult} Pendientes de ${dscEtiqueta2}`;



    this.displayedColumns.push(this.strDscColDscAsunto);
    this.displayedColumns.push(this.strDscColDscEstado);
    this.displayedColumns.push(this.strDscColDscEntidad);
    this.displayedColumns.push(this.strDscColDscPriorizacion);

    // console.log("?=??????===========ANTESSSSSSSS00000000000000");
    // console.log(this.matTableColumnsDef);

    // this.displayedColumns = [];

    // this.matTableColumnsDef.forEach(element => {

    //   this.displayedColumns.push(element);

    // });

    if (this.flgMostrarAsig) { this.displayedColumns.push(this.strDscColBtnAsign); }
    if (this.flgMostrarEditar) { this.displayedColumns.push(this.strDscColBtnEdit); }
    if (this.flgMostrarAten) { this.displayedColumns.push(this.strDscColBtnAten); }
    if (this.flgMostrarVer) { this.displayedColumns.push(this.strDscColBtnVer); }

    if (this.flgContraerPanel == false) {

      (document.getElementById('collapse1a') as HTMLInputElement).click();

    }

    // console.log("?=??????===========ANTESSSSSSSS");
    // console.log(this.displayedColumns);

    // this._recuperarPorDefecto();
    this._buscar();

  }

  _recupFlgFiltroEstReg() {
    return (this.numIdEstado == NumIdEstadoRegistrado ? true : false);
  }

  _recupFlgFiltroEstAsig() {
    return (this.numIdEstado == NumIdEstadoAsignado ? true : false);
  }

  _cambioParametro() {

    this._buscar();

  }

  _datetime() {
    // document.getElementById("datetimepicker1"). datetimepicker();

  }

  _buscar() {

  }

  _recuperaListado(listFur: Fur[]) {

    listFur.forEach((element, index) => {

      element.flgDeshabilitaEditar = (element.cfurIdusureg == GlobalVars.CodPersonal && element.nfurIdestado == NumIdEstadoRegistrado ? false : true);
      element.numItem = index + 1;

    });

    this.dataSource = new MatTableDataSource(listFur);

    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;


  }

  _cambioRadio(flgEvent) {

    this.flgRadio = flgEvent.checked;
    this._resetBusqueda();

  }

  _EmitirSeleccionado(idFur: number) {
    this.opNuevoSeleccionado.emit(idFur);
  }

  _Editar(idFur: number) {

    this._EmitirSeleccionado(idFur);

  }

  _Ver(idFur: number) {

    this.opVerSeleccionado.emit(idFur);

  }

  Nuevo() {

    this._EmitirSeleccionado(0);

  }

  _Asignar(idFur: number) {

    this.opAsignarSeleccionado.emit(idFur);

  }

  _Atender(idFur: number) {

    this.opEvaluarSeleccionado.emit(idFur);

  }

}
